import { ZCDFlex, ZCDSpacer, ZCDTypography } from '@zencity/common-ui';
import classNames from 'classnames';
import React from 'react';
import { OverallSatisfactionScoreQuestion } from 'screens/WidgetGenerator/utils/misc';
import { BodyRowHeight, MAX_QUESTION_LENGTH, truncateText } from '../../helpers';
import { Cell } from '../Cell';
import { Row } from '../Row';
import styles from './BodyRow.module.scss';
import { ChangeIndicator } from './ChangeIndicator/ChangeIndicator';
import { ServicesBarChartWidgetBar } from './SatisfactionBar/ServicesBarChartWidgetBar';

interface Props {
  rowData: OverallSatisfactionScoreQuestion;
  isHighlighted?: boolean;
  rowHeight?: BodyRowHeight;
}

export const BodyRow = (props: Props) => {
  const { rowData, isHighlighted, rowHeight } = props;
  const { text } = rowData;
  const truncatedText = truncateText(text, MAX_QUESTION_LENGTH);

  return (
    <Row
      key={`${text}_element_key`}
      className={classNames(styles.root, {
        [styles.isHighlighted]: isHighlighted,
        [styles.small]: rowHeight === BodyRowHeight.SMALL,
        [styles.medium]: rowHeight === BodyRowHeight.MEDIUM,
        [styles.large]: rowHeight === BodyRowHeight.LARGE,
      })}
    >
      <Cell className={styles.questionCell}>
        <ZCDTypography variant={isHighlighted ? 't-heading-4' : 't-body'}>{truncatedText}</ZCDTypography>
      </Cell>
      <Cell>
        <ServicesBarChartWidgetBar score={rowData.score} />
      </Cell>
      <Cell>
        <ZCDFlex alignItems="center" justifyContent="center">
          <ChangeIndicator
            currentValue={rowData.score.positive}
            prevValue={rowData.previousCycle?.score.positive}
            iconColor="zcd-green-90"
            typographyColor="zcd-green-90"
            typographyVariant={isHighlighted ? 't-tag' : 't-small'}
            justifyContent="flex-end"
          />
          <ZCDSpacer orientation="horizontal" size="xsmall" />
          <ChangeIndicator
            currentValue={rowData.score.negative}
            prevValue={rowData.previousCycle?.score.negative}
            iconColor="zcd-red-30"
            typographyColor="zcd-red-30"
            typographyVariant={isHighlighted ? 't-tag' : 't-small'}
            justifyContent="flex-start"
          />
        </ZCDFlex>
      </Cell>
    </Row>
  );
};
